import React, { useRef, useState, useEffect } from "react";
import { withRouter } from "../../app-services/lib/router-compat";
import CheckoutSteps from "../preview/CheckoutSteps/CheckoutSteps";
import HTMLFlipBook from "react-pageflip";
import "./HandprintView.css";

export function HandprintView(props) {
  const { onFetch: onFetchProp = (...arg) => api.getSelfPublish(...arg) } = props;
  const onFetchRef = useRef(onFetchProp);
  onFetchRef.current = onFetchProp;
  const CUSTOMBOOKID = props.bookDetails.id;
  const $ele = useRef(null);

  const [state, setStateRaw] = useState({
    pages: [],
    bookDetails: null,
    productDetails: null,
    answers: {},
    parsedBook: null,
    bookobj: null,
  });

  const setState = (partial) => {
    setStateRaw((prev) => ({ ...prev, ...partial }));
  };

  const instanceRef = useRef(null);
  if (!instanceRef.current) {
    instanceRef.current = {};
  }
  const self = instanceRef.current;
  const prevStateRef = useRef(state);

  self.onFetch = (...args) => onFetchRef.current(...args);

  self.onBookSetup = (bookobj) => {
    setState({ bookobj });
    let previewPageNo = localStorage.getItem("previewPageNo");
    if (previewPageNo) {
      setTimeout(() => {
        bookobj.turnToPage(Number(previewPageNo));
        localStorage.removeItem("previewPageNo");
      }, 100);
    }
  };

  self.getPages = () => {
    let { getPayload } = self.props;
    return new Promise((resolve, reject) => {
      getPayload()
        .then((book) => {
          resolve(
            Object.entries(book).map(([key, value], i) => ({
              pagetype: key,
              name: key,
              label: i + 1,
              content: value.html,
            }))
          );
        })
        .catch((err) => reject(err));
    });
  };

  self.getProductDetails = () => {
    let { bookDetails, match } = self.props;
    // For a book that's never been saved yet, bookDetails (HandPrint.js's
    // savedBook state) is still {} and has no bookId of its own — but the
    // book TEMPLATE id is already known from the route itself, so fall back
    // to that instead of waiting on a save that hasn't happened.
    let bookId = bookDetails?.bookId || match?.params?.id;
    return api.getBookDetails(bookId).then((res) => {
      let productDetails = res.data.bookDetails;
      setState({ productDetails });
      return productDetails;
    });
  };

  self.getBookDetails = () => {
    let { bookDetails } = self.props;
    return new Promise((resolve, reject) => {
      if (bookDetails.id) {
        self.onFetch(bookDetails.id).then((responce) => {
          if (responce.data && Object.keys(responce.data).length) {
            let savedBookObj = responce.data || { savedBook: "{}" };
            // savedBook is a real column that can be null (a book record
            // created but never actually saved with page content yet) —
            // responce.data itself is never null/empty here, so the
            // fallback above never catches this case.
            let parsedBook = savedBookObj.savedBook
              ? savedBookObj.savedBook.parse() || {}
              : {};
            setState({
              bookDetails: savedBookObj,
              parsedBook,
            });
            resolve(savedBookObj);
          }
        });
      }
    });
  };

  self.getPageSize = (name) => {
    let { bookname } = self.props;
    let booksize = self.$store?.bookSize?.[bookname];
    if (booksize && booksize[name]) {
      return `${booksize[name]}${booksize["unit"]}`;
    } else {
      return "";
    }
  };

  self.getCorrection = (attributeName) => {
    let device = self.$store?.device;
    let correct = 0;
    let { bookname } = self.props;
    if (["picture-book", "handprint-book"].includes(bookname)) {
      switch (device) {
        case "desk":
          correct = `${(1 - 0.8).toFixed(2).parse() * 200}mm`.toPx();
          break;
        case "lap":
        case "mac":
          correct = `${(1 - 0.6).toFixed(2).parse() * 200}mm`.toPx();
          break;
      }
    }
    return correct;
  };

  self.onPage = (obj, i, arr) => {
    return {
      ...obj,
      content: () => (
        <div>
          <div dangerouslySetInnerHTML={{ __html: obj.content || "" }}></div>
          <div className="col text-center">
            <b>{obj.label}</b> / {arr.length}
          </div>
        </div>
      ),
    };
  };

  self.onAnswer = (value, key) => {
    let { answers } = self.state;
    let { onUpdate } = self.props;
    if (key == "dedication") {
      onUpdate(key, value);
    }
    setState({
      answers: {
        ...answers,
        [key]: value,
      },
    });
  };

  self.onDedicationSave = () => {
    let { saveBook, bookname } = self.props;
    return new Promise((resolve, reject) => {
      saveBook()
        .then(() => {
          self.props.alert.close();
          setTimeout(() => {
            if (bookname === "customcharacter-book") {
              localStorage.setItem("previewPageNo", 18);
            }
            document.querySelector(".right-toolbar #previewBook").click();
            resolve();
          }, 100);
        })
        .catch(reject);
    });
  };

  self.checkoutSave = () => {
    return new Promise((resolve, reject) => {
      self.onDedicationSave().then(() => {
        let { bookDetails } = self.state;
        setState({
          productDetails: { ...bookDetails, triggeradd2cart: true },
        });
        self.setStore("triggeradd2cart", true);
      });
    });
  };

  self.addToCart = () => {
    let { productDetails, answers, bookDetails } = self.state;
    let { saveBook, getPayload, history } = self.props;
    mixins
      .checkLogin(history)
      .then(async (user) => {
        if (!productDetails) {
          // Previously this called self.checkoutSave(), which closes the
          // preview modal and reopens it (self.props.alert.close(), then a
          // click on #previewBook) to run the dedication-save flow. Handprint
          // has no dedication step (getStepKeys() => ["edit"]), so that whole
          // round trip was unnecessary here — worse, closing the modal
          // remounts this component from scratch, dropping this in-flight
          // click. The reopened instance's mount effect fetches productDetails
          // fresh, so the click only actually completed once the user clicked
          // "Add to cart" a second time in the reopened view. Fetch product
          // details inline instead and keep going in this same call so the
          // very first click completes on its own.
          productDetails = await self.getProductDetails();
          if (!productDetails) {
            alert("Something went wrong please try again later..");
            return;
          }
        }
        {
          let payload = await getPayload();
          let savedBook = await emit.trigger("updatebook", payload);
          // For a book that's never been saved before, self.state.bookDetails
          // (captured above, before this save) is still null — this
          // component has its own independent state and has no way to
          // know the book now exists otherwise. The "updatebook" listener
          // (HandPrint.js's self.updateBook) returns the freshly
          // created/updated record precisely so this can pick it up.
          if (savedBook) {
            bookDetails = savedBook;
          }
        }
        Modal.state.list.filter((o) => o.type == "alert")[0]?.close();
        if (localStorage.getItem("editmode") === "true") {
          api
            .updateToCart(
              {
                promotionId: null,
                productId: productDetails?.product?.id,
                quantity: 1,
                price: productDetails?.book?.bookPrice,
                discount: null,
                bookCover: answers.cover || null,
                customProductId: self.props.store.cartdetails?.customProductId,
              },
              self.props.store.cartdetails?.id
            )
            .then((res) => {
              localStorage.setItem("editmode", false);
              if (res && res.statusCode === 200) {
                self.props.alert.close();
                history.push("/checkout-page");
              } else {
                alert(res?.message || "Something went wrong please try again later..");
              }
            })
            .catch(() => {
              alert("Something went wrong please try again later..");
            });
        } else {
          api
            .addToCart({
              promotionId: null,
              productId: productDetails?.product?.id,
              quantity: 1,
              price: productDetails?.book?.bookPrice,
              discount: null,
              bookCover: answers.cover || null,
              customBookId: bookDetails?.customBook?.id,
            })
            .then((res) => {
              if (res && res.statusCode === 200) {
                self.props.alert.close();
                history.push("/checkout-page");
                mixins.reFectchSavedBookDetails(self.props);
              } else {
                alert(res?.message || "Something went wrong please try again later..");
              }
            })
            .catch(() => {
              alert("Something went wrong please try again later..");
            });
        }
      })
      .catch((error) => {
        // Without this, a save failure inside emit.trigger("updatebook", ...)
        // (or anything else above) rejects silently: no alert, no navigation,
        // the button just appears to do nothing.
        console.error("addToCart failed", error);
        alert("Something went wrong while saving your book. Please try again.");
      });
  };

  self.getStepKeys = () => {
    let { bookname } = self.props;
    switch (bookname) {
      case "customcharacter-book":
        return ["edit", "dedication"];
      case "handprint-book":
        return ["edit"];
      default:
        return [];
    }
  };

  Object.assign(self, {
    props,
    state,
    setState,
    $ele,
    CUSTOMBOOKID,
    history: props.history,
  });

  self.props = props;
  initialConstruct.bind(self)("BookPreview", props);

  useEffect(() => {
    window.HandprintView = self;
    self.getPages().then((pages) => {
      setState({ pages });
      // self.getBookDetails()'s promise only resolves when bookDetails.id
      // (the saved custom-book id) is already set — for a brand new book
      // that's never true, so it used to silently swallow getProductDetails
      // along with it and productDetails stayed null forever, making the
      // very first "Add to cart" click always fall into the checkoutSave
      // fallback below. Fetch product details independently so it loads
      // regardless of whether the book has been saved yet.
      self.getBookDetails();
      self.getProductDetails();
    });
  }, []);

  useEffect(() => {
    mixins.debounce(document, () => {}, "customCharacter.8.ans.dedication");
    self.watch(
      {
        productDetails: function (val) {
          if (props.store.triggeradd2cart) {
            this.setStore("triggeradd2cart", false);
            setTimeout(() => {
              this.addToCart();
            });
          }
        },
      },
      state,
      prevStateRef.current
    );
    prevStateRef.current = state;
  });

  const { bookname } = props;
  const { pages } = state;

  return ((
    {
      alert,
      message,
      closablePreview = true,
      onPreviewClose = (a) => a.close(),
    },
    { pages: statePages, bookDetails, productDetails }
  ) => (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-10 offset-md-1">
            <div className={"bookView handprintcus " + bookname}>
              {closablePreview && (
                <i
                  className="close fa fa-times"
                  onClick={() => onPreviewClose(alert)}
                ></i>
              )}
              {statePages.length > 0 && (
                <HTMLFlipBook
                  width={200}
                  height={200}
                  size="stretch"
                  maxShadowOpacity={0.5}
                  showCover={true}
                  mobileScrollSupport={true}
                  className="demo-book"
                >
                  {statePages.map((o, index) => {
                    return (
                      <div
                        key={index}
                        className={"demoPage " + (index == 0 ? 'front-page' : index == statePages.length-1 ? 'backcover': index % 2 == 1 ? 'left-page' : 'right-page')}
                        style={{ position: "relative" }}
                        dangerouslySetInnerHTML={{ __html: o?.content }}
                      ></div>
                    );
                  })}
                </HTMLFlipBook>
              )}
            </div>
            {message && (
              <div
                className="col text-center"
                style={{ fontWeight: "bold", color: "red" }}
                dangerouslySetInnerHTML={{ __html: message }}
              ></div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="my-5">
              {
                <CheckoutSteps
                  keys={self.getStepKeys()}
                  addToCart={() => self.addToCart()}
                  onAnswer={(v, k) => self.onAnswer(v, k)}
                  onSave={(v) => self.onDedicationSave(v)}
                  bookname={bookname}
                />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  ))(props, state, self);
}

export default connect(withRouter(HandprintView));
